import { Text } from 'blaze-ui/Text/Text'
import Styles from './ContentModification.module.scss'
import type { Icon } from 'blaze-ui/icons/Types'
import { Brand } from 'blaze-ui/icons'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { AnnotationX, ColorSwatch01 } from 'blaze-ui/icons/24'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { SourceImageEditLevel } from 'types'
import { Pressable } from '@react-aria/interactions'

type Variant = 'none' | 'low' | 'medium' | 'high'

export const ICON_MAP: Record<Variant, Icon> = {
  high: Credits,
  medium: ColorSwatch01,
  low: Brand,
  none: AnnotationX,
}

export const LABEL_MAP: Record<Variant, string> = {
  high: 'Optimized',
  medium: 'Balanced',
  low: 'Brand-first',
  none: 'Strict brand control',
}

export const DESCRIPTION_MAP: Record<Variant, string> = {
  high: 'Gives the most creative freedom to enhance your content for a more polished, visually compelling result.',
  medium: 'Improves styling and composition while keeping more of your original content intact.',
  low: 'Applies lighting improvements while preserving the original look and feel.',
  none: 'Uses your original assets with no enhancements for maximum brand control. ',
}

export const MOBILE_DESCRIPTION_MAP: Record<Variant, string> = {
  high: 'Gives the most creative freedom to enhance your content for a visually compelling result.',
  medium: 'Improves styling and composition while keeping more of your original content intact.',
  low: 'Applies lighting improvements while preserving the original look and feel.',
  none: 'Uses your original assets with no enhancements for maximum brand control. ',
}

type Props = {
  selected: boolean
  variant: Variant
  onSelect: (value: SourceImageEditLevel) => void
}

export const ContentModificationRow = (props: Props) => {
  const { variant, selected, onSelect } = props
  const IconComponent = ICON_MAP[variant]
  const label = LABEL_MAP[variant]
  const description = DESCRIPTION_MAP[variant]

  return (
    <Pressable onPress={() => onSelect(variant)}>
      <div className={Styles.rowRoot}>
        <RadioBullet isSelected={selected} size={20} noMargin />
        <div className={Styles.rowIcon}>
          <IconComponent size={16} color="#8341DF" />
        </div>
        <div className={Styles.rowText}>
          <Text color="var(--dark-90)">{label}</Text>
          <Text variant="secondary" color="var(--dark-40)">
            {description}
          </Text>
        </div>
      </div>
    </Pressable>
  )
}
